import { createFileRoute } from '@tanstack/react-router';
import { SlcpTable } from '@/components/shared/SlcpTable';

export const Route = createFileRoute('/(client)/slcp/(pages)/(list)/network/')({
  component: NetworkSlcpPage,
});

function NetworkSlcpPage() {
  return <SlcpTable />;
}
